import { IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ParameterConfig } from './parameter-config';

@Metamodel.model({})
export class ParameterConfigWrapper {
    public static readonly VALUES: IAttribute;

    public name: string = '';

    @Metamodel.attribute({
        templatable: true,
        accepts: ['Any'],
        association: 'VALUES'
    })
    public values: ParameterConfig[];
}
